import { useQuery, useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { useLoading } from "../../context/loadingContext";

const apiListaSolicitudes = async (params) => {
  const { data } = await clienteAxios.get("/sucursalVirtual/crm/clientes/solicitudSV", {params});
  return data;
};

const useListSolicitudes = () => {
  return useMutation(apiListaSolicitudes, {
    onSuccess: (response) => {

    },
    onError: (error) => {
    },
  });
};

export default useListSolicitudes